





































































































import { GPageBase } from '@/mixins';
import { mapActions, mapState } from 'vuex';
import { mixins } from 'vue-class-component';
import { email } from 'vuelidate/lib/validators';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import GVTag from '@/components/GVTag.vue';
import { GEnum } from '@/constants/enum.defination';
import { SocialLoginDef } from '@/constants/socialLoginDef';
import { jgrowStatusModule } from '@/store/modules/frames/jgrow-status.module';
import { socialAuthService } from '@/service/api/social-auth.service';

@Component({
  name: 'GSignin',
  components: {
    GVTag,
  },
  computed: {
    ...mapState('signin', ['email', 'password', 'apiError', 'isLicenseExpired']),
  },
  methods: {
    ...mapActions('signin', ['signin']),
  },
  validations: {
    email: { email },
  },
})
export default class GSignin extends mixins(GPageBase) {
  copyRightYear: number = new Date().getFullYear();
  mounted() {
    this.$store.dispatch('getDashboardInfo');
    this.$store.commit('signin/email', '');
    this.$store.commit('signin/password', '');
    this.$store.commit('signin/apiError', undefined);
    this.$store.commit('signin/isLicenseExpired', false);
  }
  handleEnter() {
    if (this.hasInputEmailAndPassword) {
      this.$store.dispatch('signin/signin');
    }
  }

  handleGoogleLogin() {
    socialAuthService.doOAuthSignin(SocialLoginDef.Google);
  }

  handleMicrosoftLogin() {
    socialAuthService.doOAuthSignin(SocialLoginDef.Microsoft);
  }

  @Watch('isAuthCodeRequire')
  showSendAuthCodeNotice(val: boolean, old: boolean) {
    if (val) {
      this.showNotice(GEnum.MessageType.Info, this.$t('NOTICE_AUTH_CODE_SEND').toString(), this.$t('NOTICE_CHECK_EMAIL').toString());
    }
  }

  @Watch('isAuthCodeFail')
  showAuthCodeFailError(val: boolean, old: boolean) {
    if (val) {
      this.showNotice(GEnum.MessageType.Error, this.$t('NOTICE_AUTH_CODE_ERROR').toString(), this.$t('NOTICE_CHECK_EMAIL').toString());
    }
  }

  get email(): string {
    return this.$store.state.signin.email;
  }
  set email(value: string) {
    this.$store.commit('signin/email', value);
  }

  get isNotValidEmail() {
    return this.$v.email.$error && !this.$v.email.email;
  }

  get password(): string {
    return this.$store.state.signin.password;
  }
  set password(value: string) {
    this.$store.commit('signin/password', value);
  }

  get authCode(): string {
    return this.$store.state.signin.authCode;
  }
  set authCode(value: string) {
    this.$store.commit('signin/authCode', value);
  }

  get isAuthCodeRequire(): boolean {
    return this.$store.state.signin.authCodeRequire;
  }

  get isAuthCodeFail(): boolean {
    return this.$store.state.signin.authCodeFail;
  }

  get hasInputEmailAndPassword(): boolean {
    return this.email.length > 0 && this.password.length > 0 && !this.isNotValidEmail;
  }

  get copyRight(): string {
    return `&copy;${new Date().getFullYear()} Institution for a Global Society`;
  }

  get dashboardInfoText(): string {
    if (this.$store.state.dashboardInfo === undefined) {
      return '';
    }
    return this.$store.state.dashboardInfo.htmlText;
  }

  get isJgrow(): boolean {
    return jgrowStatusModule.isJgrow;
  }
}
